<template>
  <div>
    <div>
      <div class="fundo-preto-opacity"></div>
      <div class="icone-share" v-if="webShareApiSupported">
        <div class="svg">
          <svg
            @click="shareViaWebShare"
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            class="bi bi-share-fill"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"
            />
          </svg>
        </div>
      </div>
      <div class="img-hero" v-if="exibeImagem(urlImageBanner)">
        <div>
          <Imagem :caminhoImagem="urlImageBanner"></Imagem>
        </div>
      </div>

      <div class="content-size section-home you-might-like">
        <div style="font-weight: 600;">{{ textTipoEstabelecimento }}</div>
        <div class="yml-food-text">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-shop"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M0 15.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zM3.12 1.175A.5.5 0 0 1 3.5 1h9a.5.5 0 0 1 .38.175l2.759 3.219A1.5 1.5 0 0 1 16 5.37v.13h-1v-.13a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.13H0v-.13a1.5 1.5 0 0 1 .361-.976l2.76-3.22z"
            />
            <path
              d="M2.375 6.875c.76 0 1.375-.616 1.375-1.375h1a1.375 1.375 0 0 0 2.75 0h1a1.375 1.375 0 0 0 2.75 0h1a1.375 1.375 0 1 0 2.75 0h1a2.375 2.375 0 0 1-4.25 1.458 2.371 2.371 0 0 1-1.875.917A2.37 2.37 0 0 1 8 6.958a2.37 2.37 0 0 1-1.875.917 2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.5h1c0 .76.616 1.375 1.375 1.375z"
            />
            <path
              d="M4.75 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm3.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm3.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
            />
            <path
              fill-rule="evenodd"
              d="M2 7.846V7H1v.437c.291.207.632.35 1 .409zm-1 .737c.311.14.647.232 1 .271V15H1V8.583zm13 .271a3.354 3.354 0 0 0 1-.27V15h-1V8.854zm1-1.417c-.291.207-.632.35-1 .409V7h1v.437zM3 9.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V15H7v-5H4v5H3V9.5zm6 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4zm1 .5v3h2v-3h-2z"
            />
          </svg>
          {{ textEndereco }}
        </div>
        <div class="yml-food-text">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-alarm"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M8 15A6 6 0 1 0 8 3a6 6 0 0 0 0 12zm0 1A7 7 0 1 0 8 2a7 7 0 0 0 0 14z"
            />
            <path
              fill-rule="evenodd"
              d="M8 4.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.053.224l-1.5 3a.5.5 0 1 1-.894-.448L7.5 8.882V5a.5.5 0 0 1 .5-.5z"
            />
            <path
              d="M.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.035 8.035 0 0 0 .86 5.387zM11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.035 8.035 0 0 0-3.527-3.527z"
            />
            <path
              fill-rule="evenodd"
              d="M11.646 14.146a.5.5 0 0 1 .708 0l1 1a.5.5 0 0 1-.708.708l-1-1a.5.5 0 0 1 0-.708zm-7.292 0a.5.5 0 0 0-.708 0l-1 1a.5.5 0 0 0 .708.708l1-1a.5.5 0 0 0 0-.708zM5.5.5A.5.5 0 0 1 6 0h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
            />
            <path d="M7 1h2v2H7V1z" />
          </svg>
          {{ textHorarioFuncionamento }}
        </div>
        <div class="yml-food-text" v-show="textHorarioFuncionamento1">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-alarm"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M8 15A6 6 0 1 0 8 3a6 6 0 0 0 0 12zm0 1A7 7 0 1 0 8 2a7 7 0 0 0 0 14z"
            />
            <path
              fill-rule="evenodd"
              d="M8 4.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.053.224l-1.5 3a.5.5 0 1 1-.894-.448L7.5 8.882V5a.5.5 0 0 1 .5-.5z"
            />
            <path
              d="M.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.035 8.035 0 0 0 .86 5.387zM11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.035 8.035 0 0 0-3.527-3.527z"
            />
            <path
              fill-rule="evenodd"
              d="M11.646 14.146a.5.5 0 0 1 .708 0l1 1a.5.5 0 0 1-.708.708l-1-1a.5.5 0 0 1 0-.708zm-7.292 0a.5.5 0 0 0-.708 0l-1 1a.5.5 0 0 0 .708.708l1-1a.5.5 0 0 0 0-.708zM5.5.5A.5.5 0 0 1 6 0h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
            />
            <path d="M7 1h2v2H7V1z" />
          </svg>
          {{ textHorarioFuncionamento1 }}
        </div>
        <div class="yml-food-text" v-show="textHorarioFuncionamento2">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-alarm"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M8 15A6 6 0 1 0 8 3a6 6 0 0 0 0 12zm0 1A7 7 0 1 0 8 2a7 7 0 0 0 0 14z"
            />
            <path
              fill-rule="evenodd"
              d="M8 4.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.053.224l-1.5 3a.5.5 0 1 1-.894-.448L7.5 8.882V5a.5.5 0 0 1 .5-.5z"
            />
            <path
              d="M.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.035 8.035 0 0 0 .86 5.387zM11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.035 8.035 0 0 0-3.527-3.527z"
            />
            <path
              fill-rule="evenodd"
              d="M11.646 14.146a.5.5 0 0 1 .708 0l1 1a.5.5 0 0 1-.708.708l-1-1a.5.5 0 0 1 0-.708zm-7.292 0a.5.5 0 0 0-.708 0l-1 1a.5.5 0 0 0 .708.708l1-1a.5.5 0 0 0 0-.708zM5.5.5A.5.5 0 0 1 6 0h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
            />
            <path d="M7 1h2v2H7V1z" />
          </svg>
          {{ textHorarioFuncionamento2 }}
        </div>
        <div class="yml-food-text">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-telephone"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
            />
          </svg>
          <a :href="`tel:` + textTelefone">{{ textTelefone }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Imagem from "@/components/Imagem";

import FunctionsMixin from '@/utils/functionsMixin.js'

export default {
  name: "Cardapios-Banner",

  components: {
    Imagem
  },

  mixins: [FunctionsMixin],

  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
    urlImageBanner() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : this.$store.state.dadosEstabelecimento.banner;
    },
    textNomeFantasia() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : this.$store.state.dadosEstabelecimento.nomeFantasia;
    },
    textTipoEstabelecimento() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : (this.$store.state.dadosEstabelecimento.tipoEstabelecimentoIdioma
          ? this.$store.state.dadosEstabelecimento.tipoEstabelecimentoIdioma[this.$i18n.locale]
          : this.$store.state.dadosEstabelecimento.tipoEstabelecimento)
    },
    textEndereco() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : this.$store.state.dadosEstabelecimento.endereco;
    },
    textHorarioFuncionamento() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : (this.$store.state.dadosEstabelecimento.horariosFuncionamentoIdioma
          ? this.$store.state.dadosEstabelecimento.horariosFuncionamentoIdioma[this.$i18n.locale]
          : this.$store.state.dadosEstabelecimento.horariosFuncionamento)
    },
    textHorarioFuncionamento1() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : (this.$store.state.dadosEstabelecimento.horariosFuncionamentoIdioma
          ? this.$store.state.dadosEstabelecimento.horariosFuncionamentoIdioma[this.$i18n.locale + '1']
          : this.$store.state.dadosEstabelecimento.horariosFuncionamento)
    },
    textHorarioFuncionamento2() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : (this.$store.state.dadosEstabelecimento.horariosFuncionamentoIdioma
          ? this.$store.state.dadosEstabelecimento.horariosFuncionamentoIdioma[this.$i18n.locale + '2']
          : this.$store.state.dadosEstabelecimento.horariosFuncionamento)
    },
    textTelefone() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : this.$store.state.dadosEstabelecimento.telefone;
    }
  },

  methods: {
    shareViaWebShare() {
      try {
        navigator.share({
          title: this.textNomeFantasia + ' # ' + this.textTipoEstabelecimento,
          text: this.textNomeFantasia + ' # ' + this.textTipoEstabelecimento,
          url: this.$route.fullPath
        });
      } catch (error) {
        console.log("tag", error);
      }
    }
  }
};
</script>

<style scoped>
.fundo-preto-opacity {
  position: absolute;
  background-image: linear-gradient(black, black, black, transparent);
  width: 100%;
  height: 50px;
  margin: 0 auto;
  z-index: 5;
  top: 0;
  transform: translateY(-25px);
  opacity: 0.3;
}

.icone-share {
  position: absolute;
  z-index: 6;
  width: 100%;
  margin: 0 auto;
}

.icone-share .svg {
  position: absolute;
  z-index: 6;
  right: 15px;
  top: 10px;
  cursor: pointer;
}

@media (min-width: 1024px) {
  .icone-share {
    width: 800px;
    left: 50%;
    transform: translateX(-400px);
  }
}
</style>
